export function dataURLtoFile(dataurl, filename = "image.png") {
  const arr = dataurl.split(",");
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = (mimeMatch && mimeMatch[1]) || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, { type: mime });
}

export async function compressImageFile(
  file,
  { maxWidth = 2200, maxHeight = 2200, type = "image/jpeg", quality = 0.9 } = {}
) {
  let bmp;
  try {
    bmp = await createImageBitmap(file, { imageOrientation: "from-image" });
  } catch {
    const dataURL = await new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
    bmp = await new Promise((res, rej) => {
      const img = new Image();
      img.onload = () => res(img);
      img.onerror = rej;
      img.src = dataURL;
    });
  }

  const srcW = bmp.width || bmp.naturalWidth;
  const srcH = bmp.height || bmp.naturalHeight;

  const scale = Math.min(1, maxWidth / srcW, maxHeight / srcH);
  const dstW = Math.round(srcW * scale);
  const dstH = Math.round(srcH * scale);

  if (
    dstW === srcW &&
    dstH === srcH &&
    (type === file.type || type === "auto")
  ) {
    try {
      bmp.close?.();
    } catch {}
    return file;
  }

  const CanvasCtor =
    typeof OffscreenCanvas !== "undefined" ? OffscreenCanvas : null;
  const canvas = CanvasCtor
    ? new OffscreenCanvas(dstW, dstH)
    : (() => {
        const c = document.createElement("canvas");
        c.width = dstW;
        c.height = dstH;
        return c;
      })();

  const ctx = canvas.getContext("2d", { alpha: type === "image/png" });
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(bmp, 0, 0, dstW, dstH);

  const outType =
    type === "auto"
      ? /\bpng$/i.test(file.type)
        ? "image/png"
        : "image/jpeg"
      : type;
  const blob = CanvasCtor
    ? await canvas.convertToBlob({ type: outType, quality })
    : await new Promise((res) => canvas.toBlob(res, outType, quality));

  try {
    bmp.close?.();
  } catch {}

  const ext = outType === "image/png" ? "png" : "jpg";
  const newName = file.name.replace(/\.(\w+)$/i, "") + `_resized.${ext}`;
  return new File([blob], newName, { type: outType, lastModified: Date.now() });
}
